import * as React from 'react';
import NavbarPortal from 'src/containers/NavbarPortal';
import i18n from 'src/resources/i18n';
import QuestionnaireFormContainer from '../../containers/QuestionnaireForm';
/**
 * アンケート回答画面
 * @param props
 */
const QuestionnaireFormPortal: React.FC<any> = props => {
	const careerID = props.match.params.career_id;
	const classID = props.match.params.class_id;
	const id = props.match.params.questionnaire_id;
	const type = props.match.params.type;
	const flg: number = Number.parseInt(props.match.params.flg);

	return (
		<>
			<NavbarPortal title={i18n.t('QuestionnaireForm_0001')} />
			<QuestionnaireFormContainer
				careerID={careerID}
				classID={classID}
				id={id}
				type={type}
				flg={flg}
				assessmentFlg={false}
				onlyQuestionFlg={true}
			/>
		</>
	);
};

export default QuestionnaireFormPortal;



// WEBPACK FOOTER //
// ./src/pages/personal/QuestionnaireFormPortal.tsx